import React, { Component } from 'react';
import PromptManager from './promptManager';

/*
    editPrompt = (
        <PromptManager prompt={prompt} data={this.props.data.Prompts} cancel={this.cancel} ws={this.props.ws} />
    )
*/


class PromptPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: 'new'
        };
    }
    handleSelectChange = (event) => {
        //This will send an update out to the parent component to track
        const selectedId = event.target.value;
        console.log("Selected ID: ", selectedId);

        // Find the selected prompt using the selected ID
        const selectedPrompt = this.props.prompts.data.find(function (prompt) {
            //console.log(prompt.id);
            if (prompt.id === selectedId) {
                return true
            } else {
                return false
            }
        });
        console.log("Selected Prompts: ", selectedPrompt);
        this.setState({ selectedOption: selectedPrompt });

        if (this.props.selectionChange) {
            if (selectedPrompt) {
                // If a prompt with the selected ID was found, create a result object to send to the selectionChange prop function
                const result = {
                    id: selectedId,
                    url: selectedPrompt.url
                };
                this.props.selectionChange(event, result);
            } else {
                // If no prompt was found, send a result object with the selected ID and empty urls object
                const result = {
                    id: selectedId,
                    url: {}
                };
                this.props.selectionChange(event, result);
            }
        }
    };

    editPrompt = (id) => e => {
        //Pull the proper prompt based on id from this.props.prompts.data array
        if (id === 'new') {
            const prompt = this.props.prompts.data.filter(prompt => prompt.id === id)[0];
            this.setState({ editPrompt: true, prompt: null })
        } else {
            const prompt = this.props.prompts.data.filter(prompt => prompt.id === id)[0];

            console.log("Prompt to send to editor: " + prompt)
            this.setState({ editPrompt: true, prompt: prompt })
        }

    }
    cancel = () => {
        this.setState({ editPrompt: false, prompt: null })
    }



    render() {
        const { prompts, itemindex, currentPrompt, selectionChange, ws } = this.props;
        //filter prompts to only custom types 
        //console.log(prompts);
        //Check if currentPrompt is an object or a string
        //If it's a string, it's an id, if it's an object, it's a prompt

        var promptToEdit = null;
        if (typeof currentPrompt === 'object') {
            promptToEdit = currentPrompt.id;
        }
        if (!currentPrompt) {
            promptToEdit = 'new';
        } else {
            this.state.selectedOption = promptToEdit;
        }
        const customPrompts = prompts.data.filter(prompt => prompt.type === 'custom');
        const specialPrompts = prompts.data.filter(prompt => prompt.type === 'special');
        const bothPrompts = specialPrompts.concat(customPrompts);
        let defaultOption;
        if (promptToEdit === "new") {
            defaultOption = <option value="new">New Prompt</option>;
        } else {
            const selectedPrompt = prompts.data.find((prompt) => prompt.id === promptToEdit);
            if (selectedPrompt) {
                defaultOption = (
                    <option key={selectedPrompt.id} value={selectedPrompt.id}>
                        {selectedPrompt.name}
                    </option>
                );
            } else {
                defaultOption = <option value="notfound">PROMPT NOT FOUND</option>;
            }
        } if (!this.state.editPrompt) {

            return (


                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', padding: '10px', borderRadius: '8px', width: '94%' }}>
                    <select
                        itemindex={itemindex}
                        style={{
                            width: this.state.selectedOption === 'new' ? '200px' : '270px',
                            padding: '8px',
                            borderRadius: '4px',
                            border: '1px solid #2A6AA9',
                            marginBottom: '10px',
                            backgroundColor: '#ffffff',
                            marginRight: '10px'
                        }}
                        onChange={this.handleSelectChange}
                    >
                        {defaultOption}
                        ({bothPrompts.map((prompt) => (
                            <option key={prompt.id} value={prompt.id}>{prompt.name}</option>
                        ))})
                    </select>
                    <button
                        style={{
                            padding: '10px',
                            width: this.state.selectedOption === 'new' ? '150px' : '70px',
                            backgroundColor: '#2A6AA9',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '4px'
                        }}
                        onClick={this.editPrompt(this.state.selectedOption)}
                    >
                        {this.state.selectedOption === 'new' ? 'Create New Prompt' : 'Edit'}
                    </button>
                </div>

            );
        } else
            return (
                <PromptManager prompt={this.state.prompt} data={prompts} cancel={this.cancel} ws={ws} />
            )
    }
}

export default PromptPicker;
